import { LandingMarketSegment } from 'src/shared/hooks/useMarketSegment';
import { INDIAN_TASTES_LIKE_HOME } from './placeholderConsts';

export const getTastesLikeHomeContent = (marketSegment: LandingMarketSegment) => {
  switch (marketSegment) {
    case 'indian-community':
    case 'indian-meal-plan':
      return INDIAN_TASTES_LIKE_HOME;
    default:
      return [];
  }
};
